/**
 * src/components/ui/Pestanas.jsx
 * La barra de pestañas del panel: una franja bajo la cabecera.
 *
 * Extraída el 28-08 (hilo de distribución) cuando Suscripciones y Uso pasaron
 * a pestañas: el botón vivía copiado en cada página (y una tercera copia
 * muerta en la ficha de cliente). Dos usos reales ya son razón para que sea
 * un componente — la regla de este proyecto es no duplicar.
 *
 * `pestanas` = [{ clave, label }]. La página guarda cuál está activa.
 */

function BotonPestana({ label, activa, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: 'var(--space-2) var(--space-4)', fontSize: 'var(--text-base)',
        fontWeight: activa ? 500 : 400,
        color: activa ? 'var(--color-accent)' : 'var(--color-text-3)',
        background: 'none', border: 'none', cursor: 'pointer',
        borderBottom: activa ? '2px solid var(--color-accent)' : '2px solid transparent',
        transition: 'all 0.15s', fontFamily: 'var(--font-ui)',
      }}
    >
      {label}
    </button>
  )
}

export function BarraPestanas({ pestanas, activa, onCambio }) {
  return (
    <div style={{
      padding: '0 var(--space-6)',
      background: 'var(--color-surface)',
      borderBottom: '1px solid var(--color-border)',
      display: 'flex', gap: 'var(--space-2)',
    }}>
      {pestanas.map(p => (
        <BotonPestana key={p.clave} label={p.label}
                      activa={activa === p.clave}
                      onClick={() => onCambio(p.clave)} />
      ))}
    </div>
  )
}
